import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    user: null,
    permissions: [],
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setAuth: (state, action) => {
            return {
                ...state,
                ...action.payload,
            };
        },
        clearAuth: () => {
            return initialState;
        },
        updateProfile: (state, action) => {
            state.user = { ...state.user, ...action.payload };
        },
    },
})

export const { setAuth, clearAuth, updateProfile } = authSlice.actions;
export const selectAuth = (state) => state.auth;
export default authSlice.reducer;